import { heroData } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[620px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden pt-16 md:pt-20">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -right-40 -top-40 w-[600px] h-[600px] rounded-full bg-primary-100/40"></div>
        <div className="absolute -left-20 -bottom-20 w-[400px] h-[400px] rounded-full bg-accent-100/30"></div>
        <div className="absolute right-1/4 top-1/3 w-[200px] h-[200px] rounded-full bg-secondary-100/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <p className="inline-block text-sm font-medium text-accent-600 bg-accent-50 px-4 py-1.5 rounded-full mb-4">
              {heroData.tagline}
            </p>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-3">
              {heroData.title}
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading mb-6">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-8">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <p className="text-2xl md:text-3xl font-bold text-foreground-950">{stat.value}</p>
                  <p className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                {heroData.primaryCta}
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-8 py-3 bg-background-100 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer border border-background-200"
              >
                {heroData.secondaryCta}
                <i className="ri-arrow-down-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20comic%20book%20reading%20scene%20illustration%20with%20floating%20manga%20pages%20and%20speech%20bubbles%20featuring%20characters%20from%20Korean%20manhwa%20Japanese%20manga%20and%20Chinese%20manhua%20styles%20blended%20together%20warm%20energetic%20atmosphere%20clean%20gradient%20background%20artistic%20modern%20illustration&width=800&height=600&seq=hero-visual-01&orientation=landscape"
                alt="YY漫画 - 韩漫日漫国漫一站式阅读平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/20 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}